<nav class="nsw-side-nav mobile-side-nav-menu" role="navigation" aria-label="Beachwatch partners" >
	<div class="nsw-side-nav__header--fullwidth has-children" role="none" >
		<a routerLink="/beachwatchPartners">Beachwatch partners</a>
		<button class="side-nav__toggle" 
			aria-label="Beachwatch partners" [attr.aria-expanded]="mobileMenuExpanded" aria-controls="secondaryNavMobile0"
			(click)="onExpandMobileMenuClicked($event)">
			<span class="material-icons nsw-material-icons notranslate" focusable="false" aria-hidden="true">keyboard_arrow_down</span>
		</button>
	</div>
  	<ul class="nav-list" *ngIf="mobileMenuExpanded" role="tree" id="secondaryNavMobile0" [attr.aria-hidden]="!mobileMenuExpanded">
        <li *ngFor="let item of allPartners; let i = index"  role="none" routerLinkActive="active-item" style="width:100%">
            <a                            
                [routerLink]="['/beachwatchPartners', item.Identifier?.toString()]" 
                [state]="{ partner : item, name : item.PartnerName ?? '', allPartners : allPartners}">
                {{item.PartnerName}}
            </a>
        </li>		
	</ul>
</nav>

    
<app-bread-crumb 
    [Locations]="[{target : '/home', label : 'Home'}, {target : '/beachwatchPartners', label : 'Beachwatch partners'}]" 
    [current]="partnerDetails?.PartnerName ?? ''">
</app-bread-crumb>
      
<div class="nsw-container">
    <div class="nsw-layout">       
        <div class="nsw-layout__sidebar nsw-layout__sidebar--desktop">            
            <nav class="nsw-side-nav js-mega-menu scroll desktop-side-nav-menu" aria-label="Beachwatch partners">
                <div class="nsw-side-nav__header" id="beachwatchPartnersNavMenu">
                    <a routerLink="/waterMonitoring" aria-label="Beachwatch partners">Beachwatch partners</a>
                </div>
                <ul class="nav-list">
                    <li *ngFor="let item of allPartners; let i = index" routerLinkActive="active-item">
                        <a                           
                            [routerLink]="['/beachwatchPartners', item.Identifier?.toString()]" 
                            [state]="{ partner : item, name : item.PartnerName ?? '', allPartners : allPartners}">
                            {{item.PartnerName}}
                        </a>
                    </li>                            
                </ul>                        
            </nav>
        </div>              
          
        <main class="nsw-layout__main">
            <div class="nsw-block">
                <h2>{{partnerDetails?.PartnerName ?? ""}}</h2>
                <p>{{partnerDetails?.Description ?? ""}}</p>
            </div>
            <button type="button" class="nsw-button nsw-button--dark-outline-solid" id="partnerSiteLinkButton">             
                <app-external-link [text]="partnerDetails?.PartnerName ?? ''" [link]="partnerDetails?.Website"></app-external-link>      
            </button>

            <nav class="nsw-in-page-nav" aria-labelledby="in-page-nav">
                <div id="in-page-nav" class="nsw-in-page-nav__title">On this page</div>
                <ul>
                    <li>
                        <a [routerLink]="['./']" fragment="programDetailsSection">Program details</a>
                    </li>
                    <li>
                        <a [routerLink]="['./']" fragment="partnerBeachesSection">Latest results</a>
                    </li>
                    <li>
                        <a [routerLink]="['./']" fragment="annualReportsSection">Annual reports</a>
                    </li>
                    <li>
                        <a [routerLink]="['./']" fragment="downloadDataSection">Download data</a>
                    </li>
                </ul>
            </nav>

            <div class="nsw-block" id="programDetailsSection">
                <h2 id="programDetailsSectionTitle">Program details</h2>                 
            </div>

            <div class="nsw-table nsw-table--bordered" [tabindex]="0">
                <table>                        
                    <thead>
                        <tr>
                            <th>Number of sites</th>
      
                            <th>Sampling frequency and monitoring period</th>                               
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template ngFor [ngForOf]="partnerDetails?.ProgramDetails" let-program let-i="index">
                            <tr>
                                <td>{{program.NumberOfSites}}</td>
                          
                                <td>{{program.MonitoringPeriod}}</td>
                            </tr>                                
                        </ng-template> 
                    </tbody>
                </table>
            </div>


            <div class="nsw-block" id="partnerBeachesSection">
                <h2 id="partnerBeachesSectionTitle">Latest results</h2>  
                <p>
                    If you're unsure about the safety of swimming at your local beach or swimming spot, speak to the lifeguards on duty or give local council a call.
                </p>  
            </div>

            <div class="weather-table-container nsw-table nsw-table--caption-top" [tabindex]="0">
                <table>
                    <thead>
                        <tr>
                            <th style="width:30%">Swimming Site</th>
                            <th style="width:30%">Latest result</th>
                            <th style="width:20%">Site type</th>
                            <th style="width:20%">Last tested</th>
                        </tr>
                    </thead>
                    <tbody>
                        <ng-template ngFor [ngForOf]="partnerSites" let-site let-i="index">
                            <tr>
                                <td class="siteLink" style="width:30%">
                                    <a class="link-deep-sapphire-underlined" 
                                        [routerLink]="['/siteDetails', site.Identifier]" target="_blank" rel="bookmark">
                                        <span>{{site.SiteName}}</span>
                                    </a>
                                </td>
                                <td >                                       
                                    <app-site-rating [rating]="site?.LatestResultStarRating"></app-site-rating>                                    
                                </td>
                                <td class="siteType">
                                    <span class="siteType">{{site.SiteType}}</span>                                    
                                </td>
                                <td style="padding-left:0">
                                    <ng-container *ngIf="site.LastTested">
                                        <app-last-updated-widget dateOutFormat="dd/MM/YY" [updatedDate]="site?.LastTested"></app-last-updated-widget>
                                    </ng-container>                                        
                                </td>
                            </tr>
                        </ng-template>                                
                    </tbody>
                </table>
            </div>

            <div class="nsw-block" id="annualReportsSection">
                <h2 id="annualReportsSectionTitle">Annual reports</h2> 
                <p>Beach grades are reported in the annual State of the Beaches report and provide a long-term assessment of how suitable a site is for swimming.</p>                
            </div>
            <div class="nsw-link-list">
                <ul> 
                    <li>
                        <a *ngIf="partnerLatestReportLink" 
                            (mousedown)="navigateToStateOfBeaches()"
                            target="_blank"
                            [href]="partnerLatestReportLink">
                            <span>Latest State of the Beaches report</span>
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
                        </a>
                        <a *ngIf="!partnerLatestReportLink" 
                            target="_blank"
                            href="#"
                            (click)="onDummyLinkClicked($event)">
                            <span>Latest State of the Beaches report</span>
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
                        </a>
                    </li>                     
                    <li>
                        <a (mousedown)="navigateToStateOfBeaches()"
                            target="_blank"
                            [href]="STATE_OF_BEACHES_REPORT_URL">
                            <span>All State of the Beaches reports</span>
                            <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
                        </a>
                    </li>  
                </ul>
            </div>

            <div class="nsw-block" id="downloadDataSection">
                <h2 id="downloadDataSectionTitle">Download data</h2>
                <p>Data collected under the Beachwatch and our partners can be viewed or downloaded.</p>
            
                <div class="nsw-link-list" style="margin-bottom:48px;">
                    <ul>                    
                        <li>
                            <a 
                                *ngIf="partnerDetails?.PartnerName"
                                [routerLink]="['/waterMonitoring/waterQualityData']" [queryParams]="{ partnerName : partnerDetails?.PartnerName ?? '' }">
                                <span>Explore water quality data for {{partnerDetails?.PartnerName ?? ""}}</span>
                                <span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
                            </a>
                        </li>  
                    </ul>
                </div>
            </div>
        </main>
    </div>
</div>
